export default __webpack_public_path__ + "static/media/icon_Sticky_Note_.689ed1ac.svg";